import Vue from 'vue'
import App from './collectionList.vue'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#collectionList',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/pages/collectionList/collectionList.js